export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CLEAR_ALERTS ='CLEAR_ALERTS';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION';
export const GET_OFFSET_LOADING = 'GET_OFFSET_LOADING';